<template>
  <div id="app">
    <nav v-if="showTop">
      <div class="nav_content">
         <div class="nav_title" @click="homeTap">开发区金融服务平台</div>
         <div class="nav_flex">
              <el-menu :default-active="currentTop" class="el-menu-demo gradient-menu" mode="horizontal" @select="handleSelect"   text-color="rgba(0,0,0,0.78)"  active-text-color="#333" >
                <el-menu-item v-for="(item,i) in menuRoutes" :key="i" :index="item.path">
                  {{ item.meta.title }}
                  <label v-if="currentTop==i" class="active-label"></label>
                </el-menu-item>
              </el-menu>
              <div class="user_flex" @click="userTap">
                <label>{{ loginTitle }}</label>
                <el-image :src="avatarUrl" fit="contain" class="avatar_image"></el-image>
              </div>
         </div>
      </div>
      
    </nav>
    <div class="head_nav" v-if="showTop"></div>
    <keep-alive>
        <router-view/>
    </keep-alive>
  </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
  name: 'App',
  data(){
    return{
      // token: '',
      currentTop:"0",
      tokenValue:'',
      avatarUrl:require('@/assets/yonghu.png'),
      loginTitle:'未登录',
      showTop:true
    }
  },
  computed: {
    ...mapState(['token']),
    // 过滤出需要显示在菜单中的路由
    menuRoutes() {
      console.log(this.$router.options.routes,'尽快尽')
      return this.$router.options.routes.filter(route => route.meta && route.meta.title)
    },
  },
  watch:{
      '$route'(to){
          console.log('到:', to.path);
          if(to.path=='/login'||to.path=='/forget'||to.path=='/Register'){
            this.showTop=false;
          }else{
            this.showTop=true;
            this.getPath();
          }
      }
  },
  created() {
    if(localStorage.getItem('token')){
      let userInfo=JSON.parse(localStorage.getItem('userInfo'));
      this.loginTitle=userInfo.username;
      this.avatarUrl=userInfo.avatar;
    }
    console.log(this.$route.path,'用户中心')
  },
  mounted() {
    console.log(this.$route.path,'当前路径1111')
  },
  methods:{
    getPath(){
       const currentPath = this.$route.path;
      let savedIndex = "0"; // 默认为首页
      if (localStorage.getItem('urlObj')) {
        // console.log(JSON.parse(localStorage.getItem('urlObj')).pathTop,'哈哈斤斤计较')
        try{
          let pathObj = JSON.parse(localStorage.getItem('urlObj'))
          savedIndex = pathObj.pathTop;
        }catch(err){
          console.log(err,'urlObj解析错误')
        }
      }
    const foundIndex = this.menuRoutes.findIndex(item => item.path === currentPath);
    if (foundIndex !== -1) {
      this.currentTop = foundIndex.toString();
      localStorage.setItem('urlObj', JSON.stringify({
        path: currentPath,
        pathTop: this.currentTop
      }));
    }else{
      this.currentTop = savedIndex || "0";
    }
    },
    // 首页刷新
    homeTap(){
        if(this.$route.path=='/'){
           window.location.reload(); 
        }else{
          this.currentTop = "0";
          this.$router.push('/');
        }
    },
    handleSelect(index) {
      let that = this;
      // console.log(this.currentTop,'几节课')
      console.log(index, '点击的路径');
      let clickedIndex = this.menuRoutes.findIndex(item => item.path === index);
      console.log(clickedIndex, '点击的索引');
      this.currentTop = clickedIndex.toString();
      if (this.$route.path != index) {
        let pathObj = {
          path: index,
          pathTop: that.currentTop
        }
        console.log(pathObj,'pathObj')
        localStorage.setItem('urlObj', JSON.stringify(pathObj));
        that.$router.push(index);
      }
    },
    // 用户点击头像跳转
    userTap(){
      if(!localStorage.getItem('token')){
        this.$router.push('/login');
      }else{
        if(this.$route.path=='/user'){
           window.location.reload(); 
        }else{
          this.$router.push('/user');
        }
      }
    },
  }

}
</script>

<style lang="scss" scoped>
#app {
  background: #F8F8F8;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

nav {
  width: 100%;
  height: 60px;
  position: fixed;
  top: 0px;
  z-index: 99;
  background: #fff !important;
  // padding: 30px;
  .nav_content{
    width: 1200px;
    margin: auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .nav_title{
      width: 240px;
      height: 60px;
      line-height: 60px;
      font-size: 24px;
      font-weight: bold;
      color: #333;
      cursor: pointer;
    }
    .nav_flex{
      width: calc(100% - 260px);
      display: flex;
    }
  }
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}
.head_nav{
  width: 100%;
  height: 60px;
}

::v-deep .gradient-menu.el-menu--horizontal {
   width: 100%;
   margin: auto;
   display: flex;
   justify-content: space-between;
  //  background: #FF8000 !important;
  // 移除激活项背景色
  .el-menu-item.is-active{
    background: transparent !important;
  }
  .el-menu-item{
    // background: #fff !important;
    position: relative;
    .active-label{
      width: 30%;
      height: 2px;
      background-color: #333;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      bottom: 10px;
    }
  }
  // 移除 hover 背景色
  .el-menu-item:hover {
    background-color: transparent !important;
  }
  > .el-menu-item.is-active{
     bottom: -2px !important; /* 向上移动 2px */
    //  height: 2px !important;  /* 可选：调整粗细 */
     border-radius: 2px !important;
     border-bottom: 0px!important;
  }
}
.user_flex{
  width: 200px;
  display: flex;
  align-items: center;
  label{
    font-size: 16px;
    font-weight: bold;
    color: #333;
    margin-right: 10px;
  }
  .avatar_image{
     width: 50px;
     height: 50px;
     border-radius:50%;
  }
}

</style>
